import {
  Flower2,
  Gift,
  Droplets,
  Infinity as InfinityIcon,
  Sparkles,
  Heart,
  CalendarDays,
  ShieldCheck,
  Leaf,
  BookOpen,
  type LucideIcon,
} from "lucide-react";

/** One icon per blog topic cluster — shared by the /blog "Browse by topic"
 *  rail, the category-hub pages, and the guide cards so the categories read
 *  consistently. Keyed by the BLOG_CATEGORIES slug. */
export const CATEGORY_ICONS: Record<string, LucideIcon> = {
  "flower-meanings": Flower2,
  "gift-guides": Gift,
  "flower-care": Droplets,
  everlasting: InfinityIcon,
  "mystery-bouquets": Sparkles,
  weddings: Heart,
  seasonal: CalendarDays,
  "pet-safe-allergy": ShieldCheck,
  "our-story": Leaf,
};

export function categoryIcon(slug: string): LucideIcon {
  return CATEGORY_ICONS[slug] ?? BookOpen;
}
